// extracted by mini-css-extract-plugin
module.exports = {"package-description":"vSSuZyJ","packageDescription":"vSSuZyJ"};